import { Link } from "react-router-dom";
import { Mail, MapPin, Globe } from "lucide-react";
import { TrackedLink } from "@/components/public/TrackedCta";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "SVM Operator", path: "/ai-operators" },
    { name: "App Builds", path: "/app-build" },
    { name: "App Rescue", path: "/app-rescue" },
    { name: "Systems Audit", path: "/systems-audit" },
    { name: "Venture Evaluation", path: "/venture-evaluation" },
    { name: "AI Capacity Snapshot", path: "/project-planner" },
    { name: "Work", path: "/work" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <footer className="border-t border-white/10 bg-[#0b0d10] text-white">
      <div className="container mx-auto px-4 py-12 lg:px-8">
        <div className="mb-10 grid gap-10 md:grid-cols-[1.1fr_0.9fr_0.9fr]">
          <div>
            <div className="relative mb-5 inline-block">
              <h2 className="text-3xl font-bold text-white">
                SVM
              </h2>
              <div className="absolute -bottom-1 left-0 right-0 h-[3px] bg-amber-300" />
            </div>
            <p className="max-w-sm text-sm font-medium leading-6 text-slate-400">
              Build the machine. Automate the growth. Own the outcome. SVM helps teams make important work easier to see, ship, and run.
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-xs font-bold uppercase tracking-[0.16em] text-amber-300">
              Start here
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {navLinks.map((link) => (
                <TrackedLink
                  key={link.path}
                  to={link.path}
                  tracking={{
                    label: link.name,
                    destination: link.path,
                    placement: "footer_start_here",
                  }}
                  className="text-sm font-semibold text-slate-400 transition-colors hover:text-white"
                >
                  {link.name}
                </TrackedLink>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4 text-xs font-bold uppercase tracking-[0.16em] text-amber-300">
              Contact
            </h3>
            <div className="space-y-3">
              <a
                href="mailto:info@shockvaluemedia.com"
                className="flex items-center space-x-2 text-sm font-semibold text-slate-400 transition-colors hover:text-white"
              >
                <Mail size={16} />
                <span>info@shockvaluemedia.com</span>
              </a>
              <div className="flex items-center space-x-2 text-sm font-semibold text-slate-400">
                <MapPin size={16} />
                <span>Chicago, IL</span>
              </div>
              <a
                href="https://shockvaluemedia.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-sm font-semibold text-slate-400 transition-colors hover:text-white"
              >
                <Globe size={16} />
                <span>shockvaluemedia.com</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-7">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm font-medium text-slate-500">
              Copyright © {currentYear} Shock Value Media — All Rights Reserved.
            </p>
            <div className="flex items-center gap-5">
              <Link
                to="/privacy"
                className="text-sm font-semibold text-slate-500 transition-colors hover:text-white"
              >
                Privacy
              </Link>
              <Link
                to="/terms"
                className="text-sm font-semibold text-slate-500 transition-colors hover:text-white"
              >
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
